import * as Sentry from '@sentry/browser'
import React from 'react'
import ReactDOM from 'react-dom'
import Dropin from './Dropin'
import OwlWrapper from './components/OwlWrapper'
import fetchCss from './standalone/fetchCss'
import getWidgetProps from './standalone/getWidgetProps'
import isProduction from './standalone/isProduction'
import nodeHasLoaded from './standalone/nodeHasLoaded'
import { OWL } from './types'
import { LandingPageConfig } from './types'

export interface UploadWidgetEnabledWindow extends Window {
  UploadWidget?: UploadWidget
  Sentry: typeof Sentry
}

export interface UploadWidget {
  q: any[]
  reInit?: typeof uploadWidgetInit
}

export const DEFAULT_DOM_ID = 'upload-widget-root'

export const uploadWidgetInit = async (config: LandingPageConfig) => {
  // @ts-ignore
  if (!(window as UploadWidgetEnabledWindow).Sentry || (process.env.SENTRY_DSN && isProduction())) {
    Sentry.init({
      dsn: process.env.SENTRY_DSN,
      environment: 'production',
    })
    Sentry.configureScope(scope => {
      scope.setTag('component', 'wtai-upload-widget')
      scope.setTag('site', config.site || '')
    })
  }
  const domId = config.domId || DEFAULT_DOM_ID
  const site = config.site

  await Promise.all([fetchCss(), nodeHasLoaded(domId)])

  const onUploadSuccess = ({ redirect }: { redirect: () => void }) => {
    redirect()
  }

  const props = {
    ...getWidgetProps(config),
    // allow any prop to be overwritten by the config
    // in playground
    ...(isProduction() ? {} : config),
    onUploadSuccess,
  }

  const Widget = site === OWL ? OwlWrapper : Dropin

  ReactDOM.render(<Widget {...props} />, document.getElementById(domId))
}

export const initGlobalNamespaces = () => {
  // @ts-ignore
  const uWindow = window as UploadWidgetEnabledWindow

  const q = uWindow.UploadWidget ? uWindow.UploadWidget.q : []

  uWindow.UploadWidget = {
    q,
    reInit: uploadWidgetInit,
  }

  const config = uWindow.UploadWidget.q[0] as LandingPageConfig

  if (config) {
    uploadWidgetInit(config)
    return
  }
  ;(uWindow.UploadWidget.q.push as any) = (_config: LandingPageConfig) => {
    ;(uWindow.UploadWidget as UploadWidget).q.push = Array.prototype.push
    uploadWidgetInit(_config)
    ;(uWindow.UploadWidget as UploadWidget).q.push(_config)
  }
}
;(function accessGlobals() {
  initGlobalNamespaces()
})()
